<section class="metadata-container">
  <section class="potential_issues">
    <section *ngIf="metadata.flags?.length > 0" class=" potential_issues_header">
      <h3 id="issues-heading">{{'metadata_component.potential_issues' | translate}}</h3>
      <ng-container *ngIf="metadata.flags?.length > 0; else noIssues">
        <ul role="list" aria-labelledby="issues-heading">
          <ng-container *ngFor="let flag of metadata.flags">
          <li *ngIf="!isKeyExcluded(flag?.key)" role="listitem">
            <ng-container >
              <ng-container *ngIf="flag?.flag.includes(':'); else noColon">
                <span class="bold">{{ flag?.flag.split(':')[0] }}</span>:{{ flag?.flag.split(':')[1] }}
              </ng-container>
              <ng-template #noColon>
                <span class="bold">{{ flag?.flag.split(' ').slice(0, 2).join(' ') }}</span> {{ flag?.flag.split('
                ').slice(2).join(' ') }}
              </ng-template>
            </ng-container>
          </li>
          </ng-container>

        </ul>
      </ng-container>
      <ng-template #noIssues>
        <p class="no-issues-message" role="status">{{ 'metadata.no_flagged_items' | translate }}</p>
      </ng-template>
    </section>
    <button class="analyze_with_ai" (click)="hasAnalysis ? openAnalysisModal() : getLLMAnalysis()"
      [class.loading]="isLoading" [disabled]="isLoading" [attr.aria-busy]="isLoading"
      [attr.aria-label]="(hasAnalysis ? 'metadata.view_ai_summary' : 'metadata.analyze_with_ai') | translate">
      <img src="../../../../../../assets/report_v2/ai-icon.svg" alt="" aria-hidden="true">
      <span *ngIf="isLoading" aria-live="polite">{{ 'metadata.analyzing' | translate }}</span>
      <span *ngIf="!isLoading">{{ (hasAnalysis ? 'metadata.view_ai_summary' : 'metadata.analyze_with_ai') | translate
        }}</span>
    </button>
  </section>
  <section class="metadata-body">
    <section class="metadata-filters">
      <label for="metadata-filter" class="visually-hidden">{{'metadata.filter_metadata' | translate}}</label>
      <select name="metadata-filter" [formControl]="filterControl" id="metadata-filter" aria-controls="metadata-table">
        <option value="flagged">{{ 'metadata.flagged_file_metadata' | translate }}</option>
        <option value="all">{{ 'metadata.all_file_metadata' | translate }}</option>
      </select>
    </section>
    <section class="metadata-table">
      <table *ngIf="displayedMetadata.length > 0; else noFlags" id="metadata-table"
        [attr.aria-label]="(filterControl?.value === 'flagged' ? 'metadata.flagged_file_metadata' : 'metadata.all_file_metadata') | translate">
        <thead>
          <tr>
            <th scope="col">{{ 'metadata.metadata' | translate }}</th>
            <th scope="col">{{ 'metadata.description' | translate }}</th>
            <th scope="col">{{ (filterControl?.value === 'flagged' ? 'metadata.exclude' :
              'metadata.exclude_include') | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of displayedMetadata; let i = index">
            <tr
              *ngIf="item?.key !== 'flags' && item?.key !== 'path' && item?.key !== 'llm_analysis' && item?.key !== 'excluded_flags' && !(anonymous == true && item?.key.toLowerCase() == 'author')"
              [class.even-row]="getVisibleIndex(item, displayedMetadata) % 2 === 0"
              [class.odd-row]="getVisibleIndex(item, displayedMetadata) % 2 !== 0">
              <th scope="row">{{ ('metadata.' + item?.key) | translate }}</th>
              <td [class.issue]="item?.flag && !isInExcludedFlags(item?.key)">
                <span *ngIf="item?.flag && !isInExcludedFlags(item?.key)" class="visually-hidden">Flagged: </span>{{ item?.value ||
                ('general.none' | translate) }}
              </td>
              <td class="right">
                <ng-container *ngIf="shouldShowButton(item?.key) && canEdit">
                  <button [class.rotate]="isInExcludedFlags(item?.key)"
                    (click)="toggleMetadataFlag(item?.key, isInFlags(item?.key))"
                    [attr.aria-label]="'metadata.exclude_flagged_metadata' | translate"
                    [attr.aria-pressed]="isInExcludedFlags(item?.key)">
                    <img src="../../../../../../assets/report_v2/close-circle.svg" alt="" aria-hidden="true">
                  </button>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <ng-template #noFlags>
        <div class="no-flags-message" role="status" aria-live="polite">
          <p>{{ (filterControl?.value === 'flagged' ? 'metadata.no_flagged_items' : '') | translate }}</p>
        </div>
      </ng-template>
    </section>
  </section>
  <app-overview-disclaimer tabindex="0" [title]="'general.overview' | translate"
    [disclaimerText]="'metadata.metadata_overview' | translate"
    [disclaimerLink]="'https://support.inspera.com/hc/en-us/articles/23324678219421-Understanding-the-Metadata-Analysis'"
    [linkText]="'new_entries.learn_more' | translate"></app-overview-disclaimer>
</section>